import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import InnerLoader from '../../components/general/inner-loader/InnerLoader';

function Notifications({ settings, loadingSettings, handleEdit,translate }) {
    const [notify_new_visitor, setnotify_new_visitor] = useState()
    const [notify_new_project, setnotify_new_project] = useState()
    const [notify_end_evaluation, setnotify_end_evaluation] = useState()
    useEffect(() => {
        setnotify_new_visitor(settings?.notifications?.notify_new_visitor)
        setnotify_new_project(settings?.notifications?.notify_new_project)
        setnotify_end_evaluation(settings?.notifications?.notify_end_evaluation)
    }, [settings?.notifications?.notify_new_visitor, settings?.notifications?.notify_new_project, settings?.notifications?.notify_end_evaluation])
    return (
        <div className='div_setting' id='notifications'>
            <h3>{translate('notification-settings')}</h3>
            <p>{translate('select-notification')}</p>

            {!loadingSettings ? (
                <>
                    <div className='all_div_setting_switch'>

                        <div className='div_setting_switch'>
                            <div>
                                <h3>{translate('visitors')}</h3>
                                <p>{translate('visitor-notification')}</p>
                            </div>
                            <div className='div_switch'>
                                <SwitchComponent checked={notify_new_visitor} onChange={(value) => {
                                    setnotify_new_visitor(value)
                                    handleEdit("notify_new_visitor", value)}} />
                            </div>
                        </div>

                    </div>

                    <div className='all_div_setting_switch'>

                        <div className='div_setting_switch'>
                            <div>
                                <h3>{translate('projects')}</h3>
                                <p>{translate('projects-notification')}</p>
                            </div>
                            <div className='div_switch'>
                                <SwitchComponent checked={notify_new_project} onChange={(value) =>{
                                    setnotify_new_project(value)
                                     handleEdit("notify_new_project", value)}} />
                            </div>
                        </div>

                    </div>

                    <div className='all_div_setting_switch'>

                        <div className='div_setting_switch'>
                            <div>
                                <h3>{translate('evaluation-time')}</h3>
                                <p>{translate('evaluation-time-notification')}</p>
                            </div>
                            <div className='div_switch'>
                                <SwitchComponent checked={notify_end_evaluation} onChange={(value) => {
                                    setnotify_end_evaluation(value)
                                    handleEdit("notify_end_evaluation", value)}} />
                            </div>
                        </div>

                    </div>

                </>
            ) : (
                <InnerLoader />
            )}
        </div>
    );
}

function SwitchComponent({ checked, onChange }) {
    return (
        <Switch
            onColor='#756bc1'
            checkedIcon={false}
            uncheckedIcon={false}
            height={20}
            width={40}
            handleDiameter={15}
            checked={checked}
            onChange={onChange}
        />
    );
}

export default Notifications;
